var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light mt-5 pt-5 pb-5"},[_c('div',{staticClass:"container-fluid text-center"},[_c('small',[_vm._v(" © "+_vm._s(_vm.currentYear)+" | SmartLodge | Build V2.3.1 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }